// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GK0Nd","question":"styles_question__25BUg","inputVisibleButton":"styles_inputVisibleButton__3BjNG","note":"styles_note__1TcIP"};